module.exports = __webpack_public_path__ + "img/dashboard-hm.48e41c1a.svg";